import {
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';

interface StyledDropdownProps<T extends string | number> {
  value: T;
  onChange: (event: SelectChangeEvent<T>) => void;
  options: T[];
  minWidth?: number;
  renderOption?: (option: T) => React.ReactNode;
  disabled?: boolean;
  emptyMessage?: string;
}

export default function StyledDropdown<T extends string | number>({
  value,
  onChange,
  options,
  minWidth = 120,
  renderOption,
  disabled = false,
  emptyMessage = 'No options',
}: StyledDropdownProps<T>) {
  return (
    <FormControl size="small" sx={{ minWidth }}>
      <Select
        value={value}
        onChange={onChange}
        variant="standard"
        disabled={disabled}
        MenuProps={{
          sx: { zIndex: 2100 },
        }}
        disableUnderline
        sx={{
          backgroundColor: '#e6e6e6',
          borderRadius: 4,
          fontWeight: 400,
          fontSize: 13,
          color: '#333',
          border: '2px solid transparent',
          '&:hover': {
            backgroundColor: '#e9e9e9',
          },
          '&.Mui-focused': {
            borderColor: (theme) => theme.palette.primary.main,
          },
          '& .MuiSelect-select': {
            padding: '6px 12px',
          },
        }}
      >
        {options.length > 0 ? (
          options.map((option) => (
            <MenuItem key={option} value={option}>
              {renderOption ? renderOption(option) : option}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>{emptyMessage}</MenuItem>
        )}
      </Select>
    </FormControl>
  );
}
